<template>
  <router-view></router-view>
</template>
<script>

  export default {
    
  }
</script>



// WEBPACK FOOTER //
// index.vue?109d87ef